import LabelField from '@app/components/atoms/LabelField/LabelField'
import { LOCALISE } from '@app/constant/DateTimeConstant'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useTranslation } from 'react-i18next'

const TimeSection = ({ errors, getValues, setValue }) => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <LabelField required title={t('CAMPAIGN.START_TIME')}>
            <DateTimePicker
              inputFormat={LOCALISE.DATE_TIME_FORMAT}
              minDateTime={new Date()}
              name="start_at"
              renderInput={(params) => <TextField fullWidth {...params} />}
              value={getValues('start_at')}
              onChange={(value) => setValue('start_at', value, { shouldValidate: true, shouldDirty: true })}
            />
            <FormHelperText error={!!errors.start_at} sx={{ pl: 2 }}>
              {errors.start_at?.message}
            </FormHelperText>
          </LabelField>
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <LabelField required title={t('CAMPAIGN.END_TIME')}>
            <DateTimePicker
              inputFormat={LOCALISE.DATE_TIME_FORMAT}
              minDateTime={new Date()}
              name="end_at"
              renderInput={(params) => <TextField fullWidth {...params} />}
              value={getValues('end_at')}
              onChange={(value) => setValue('end_at', value, { shouldValidate: true, shouldDirty: true })}
            />
            <FormHelperText error={!!errors.end_at} sx={{ pl: 2 }}>
              {errors.end_at?.message}
            </FormHelperText>
          </LabelField>
        </LocalizationProvider>
      </Grid>
    </Grid>
  )
}

export default TimeSection
